const PREVIEW_EXPERIMENT_OVERRIDE_HOSTS = new Set([
  'localhost',
  '127.0.0.1',
  '::1',
  'dev.botspot.trade',
]);

export const isPreviewExperimentOverrideHost = (hostname = window.location?.hostname || '') =>
  PREVIEW_EXPERIMENT_OVERRIDE_HOSTS.has(hostname || '');

export default isPreviewExperimentOverrideHost;
